import { getRootDomain } from "PFCore/helpers/root_domain";
import { ApiRoute } from "PFCore/utilities/routes";

const fetchCurrentAccount = () =>
  $.ajax({
    url: ApiRoute(`/api/accounts/${getRootDomain()}`),
    api_version: 2,
    headers: {
      "ACCEPT": "application/vnd.profinda+json;version=2",
      "Ui-Version": PF.config.ui_version,
      "Cache-Control": "no-cache,no-store"
    }
  });

export default fetchCurrentAccount;
